import BrandLogo from "../../atoms/brandLogo";
import { useState } from "react";
import { numberFormat } from "../../../utils";
import Delete from "../../../assets/images/Delete.svg";
import { useSelector } from "react-redux";
import { API_URL } from "../../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import wave from "../../../assets/images/waves pattern.svg";
import {
  Container,
  HeaderImage,
  Heading,
  Steps,
  Card,
  SubDiv,
  Document,
  Checkout,
} from "./styles";

function PaymentStep2({
  profile,
  checkoutData,
  setReceipt,
  setStep2,
  selectedFile,
  setSelectedFile,
  details,
  transactionDetails,
  hero
}: any) {
  const [isloading, setisloading] = useState(false);
  const businessUuid = useSelector((state: any) => state.auth.uuid);

  const toggle = () => {
    setStep2(false);
    setReceipt(true);
  };

  const submitValue: any = isloading ? (
    <div className="flex justify-center  text-[#ffffff] ...">
      <svg
        className="animate-spin  h-5 w-5  ..."
        viewBox="0 0 20 20"
        version="1.1"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>ic_fluent_spinner_ios_20_regular</title>{" "}
          <desc>Created with Sketch.</desc>{" "}
          <g
            id="🔍-System-Icons"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            {" "}
            <g
              id="ic_fluent_spinner_ios_20_regular"
              fill="#ffffff"
              fillRule="nonzero"
            >
              {" "}
              <path
                d="M10,3 C6.13401,3 3,6.13401 3,10 C3,10.2761 2.77614,10.5 2.5,10.5 C2.22386,10.5 2,10.2761 2,10 C2,5.58172 5.58172,2 10,2 C14.4183,2 18,5.58172 18,10 C18,14.4183 14.4183,18 10,18 C9.72386,18 9.5,17.7761 9.5,17.5 C9.5,17.2239 9.72386,17 10,17 C13.866,17 17,13.866 17,10 C17,6.13401 13.866,3 10,3 Z"
                id="🎨-Color"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
      <span className="ml-2">Processing...</span>
    </div>
  ) : (
    "Confirm Payment"
  );

  const submitHandle = () => {
    setisloading(true);
    let formData = new FormData();
    selectedFile?.name !== null &&
      formData.append("receipt", selectedFile, selectedFile.name);
    formData.append("businessUuid", businessUuid);
         formData.append("subtotal", "1");
          formData.append("reward", "1");
    checkoutData?.amount !== null &&
      formData.append("total", checkoutData?.amount);
    checkoutData?.phoneNumber !== null &&
      formData.append("phoneNumber", checkoutData?.phoneNumber);
    if (checkoutData?.note) {
      formData.append("description", checkoutData?.note);
      return;
    }

    axios({
      method: "post",
      url: `${API_URL}/transaction/record-credit`,
      data: formData,
      // headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          //updateProductList(response?.data?.data);
          setisloading(false);
          toggle();
        }
      })
      .catch((error) => {
        setisloading(false);
        if (
          error?.response?.status === 400 ||
          error?.response?.status === 401
        ) {
          toast.error(error?.response?.data?.message);
          setisloading(false);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  return (
    <Container className="bg-#FFF] px-[5%]  ">
      <HeaderImage>
        <img src={hero ? hero.headerImage : wave} alt="" />
      </HeaderImage>
      <Heading>
        <BrandLogo src={profile?.image} />
      </Heading>

      <Steps>Step 2 of 2</Steps>
      <Card>
        <SubDiv className="head">
          <p>Pay</p>
          <p className="font-bold">{numberFormat(checkoutData.amount)}</p>
        </SubDiv>
        <SubDiv>
          <h2>Account Number:</h2>
          <p className="text-[0.875em]">{details?.accountNumber}</p>
        </SubDiv>
        <SubDiv>
          <h2>Bank Name:</h2>
          <p className="text-[0.875em]">{details?.bankName}</p>
        </SubDiv>
        <SubDiv>
          <h2>Account Name:</h2>
          <p className="text-[0.875em]">{details?.accountName}</p>
        </SubDiv>
        {selectedFile?.name && (
          <SubDiv>
            <Document>
              <p>{selectedFile?.name}</p>
              <img
                src={Delete}
                alt="Delete"
                onClick={() => {
                  setSelectedFile(null);
                  window.location.reload();
                }}
              />
            </Document>
          </SubDiv>
        )}

        <Checkout type="submit" onClick={submitHandle}>
          {submitValue}
        </Checkout>
      </Card>
    </Container>
  );
}

export default PaymentStep2;
